import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetRadioButtonOptions } from 'modules/search/components/Facet/Options/SearchFacetRadioButtonOptions';
import { useSearchFacetSelectedValue } from 'modules/search/hooks/facets/useSearchFacetSelectedValue';
import { useSearchRadiusOptions } from 'modules/search/hooks/facets/useSearchRadiusOptions';
import type { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { useSearchLocation } from 'modules/search/zustand-stores/searchStore';

type Props = {
  variant?: SearchFacetVariant;
};

export function RadiusFacet({ variant = 'dropdown' }: Props) {
  const searchLocation = useSearchLocation();

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  const options = useSearchRadiusOptions();
  const selectedFacetValue = useSearchFacetSelectedValue('radius');

  if (!searchLocation || !searchLocation.hasGeo) return null;

  return (
    <FacetVariant icon="bulls-eye" facetType="radius" label={getText('Radius')}>
      <SearchFacetRadioButtonOptions
        facetType="radius"
        initialValue={selectedFacetValue}
        options={options}
      />
    </FacetVariant>
  );
}
